export default __webpack_public_path__ + "static/media/AskVIT (1).257660cd.png";